import { computed } from 'vue'

import { useUserStore } from '@backmarket/nuxt-layer-oauth/useUserStore'

import { ROUTE_NAMES } from '~/scopes/dashboard/constants'
import { GUEST } from '~/scopes/guest/route-names'

export function useMyOrdersRouteName() {
  const { isUserGuest } = useUserStore()

  return computed(() =>
    isUserGuest.value ? GUEST.ORDERS : ROUTE_NAMES.DASHBOARD.MY_ORDERS.SELF,
  )
}
